import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { formatDate } from "../../../../utils/dateUtils";

function ListadoVentas() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = import.meta.env.VITE_URL_SURTIDOS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_PEDIDO = import.meta.env.VITE_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_SURTIDOS = import.meta.env.VITE_URL_ARTICULOS_SURTIDOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    import.meta.env.VITE_URL_DEPARTAMENTOS_CLIENTES;
  const URL_FILEPOST = import.meta.env.VITE_URL_UPPROFILE;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalTracking, setModalTracking] = useState(false);
  const [trackingFile, setTrackingFile] = useState(null);
  const [trackingPreviewUrl, setTrackingPreviewUrl] = useState(null);
  const [isTrackingUploading, setIsTrackingUploading] = useState(false);
  const [trackingErrorMessage, setTrackingErrorMessage] = useState("");
  const [idVenta, setIdVenta] = useState(null);
  const [trackingPhoto, setTrackingPhoto] = useState("");
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [codigo, setCodigo] = useState("");

  const [activo, setActivo] = useState("");
  const [totalTotalTabla, setTotalTotalTabla] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useMemo(() => {
    axios
      .get(`${URL_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data;
        // Array para pagination
        let arrayTabla = allSurtidos
          .sort((a, b) => (a.idSurtido > b.idSurtido ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              is_active: a.is_active,
              fecha: a.fecha,
              user: a.user[0].nombre + " " + a.user[0].apellido,
              idUser: a.user[0]._id,
              pedidos: a.pedidos[0].idPedido,
              idPedido: a.pedidos[0]._id,
              clientes: a.pedidos[0].clientes[0].nombre_comercial,
              codigoClientes: a.pedidos[0].clientes[0].codigo,
              idClientes: a.pedidos[0].clientes[0]._id,
              telefono: a.pedidos[0].clientes[0].telefono,
              nombre: a.pedidos[0].clientes[0].nombre_comercial,
              observaciones: a.observaciones,
              observacionesPedido: a.pedidos[0].observaciones,
              numero: a.idSurtido,
              comisionTDC: a.pedidos[0].comisionTDC,
              comisionFlete: a.pedidos[0].comisionFlete,
              impuestos: a.pedidos[0].impuestos,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              calle: a.pedidos[0].clientes[0].calle,
              numero_ext: a.pedidos[0].clientes[0].numero_ext,
              numero_int: a.pedidos[0].clientes[0].numero_int,
              pais: a.pedidos[0].clientes[0].pais,
              estado: a.pedidos[0].clientes[0].estado,
              ciudad: a.pedidos[0].clientes[0].ciudad,
              delegacion: a.pedidos[0].clientes[0].delegacion,
              colonia: a.pedidos[0].clientes[0].colonia,
              cp: a.pedidos[0].clientes[0].cp,
              paqueteria: a.pedidos[0]?.paqueterias?.[0]?.name || "",
              idPaqueteria: a.pedidos[0]?.paqueterias?.[0]?._id || "",
              RFC: a.pedidos[0].clientes[0].RFC,
              area: a.pedidos[0].areas[0].name,
              descuento: a.descuento,
              vendedor:
                a.pedidos[0].colaboradores[0].nombre +
                " " +
                a.pedidos[0].colaboradores[0].apellido,
              idDepartamento: a.clientes[0].departamentosClientes[0]._id,
              departamentoName: a.clientes[0].departamentosClientes[0].name,
              creado:
                a.pedidos[0].creado[0].nombre +
                " " +
                a.pedidos[0].creado[0].apellido,
              fechaHora:
                moment(a.createdAt).utcOffset("-0600").format("DD-MM-YYYY") +
                " " +
                moment(a.createdAt).utcOffset("-0600").format("HH:mm:ss"),
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setSurtidos(allSurtidos);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const ListaSurtidos = comments.sort((a, b) =>
    a.idSurtido > b.idSurtido ? 1 : -1
  );

  function PDFTabla() {
    let totalTotal = 0;
    const data = ListaSurtidos.map((a) => {
      totalTotal = totalTotal + a.total_general;
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.area,
          a.vendedor,
          a.paqueteria,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.comisionFlete),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({ compressPdf: true });
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 155, 15, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Almacen",
          "Vendedor",
          "Paqueteria",
          "Flete",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalTotal),
        ],
      ],
      showFoot: "lastPage",
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = ListaSurtidos.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cliente: a.clientes,
          Almacen: a.area,
          Vendedor: a.vendedor,
          Paqueteria: a.paqueteria,
          Flete: a.comisionFlete,
          Importe: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoNotas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNotas",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Cliente",
          "Almacen",
          "Vendedor",
          "Paqueteria",
          "Flete",
          "Importe",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Cliente",
          "Almacen",
          "Vendedor",
          "Paqueteria",
          "Flete",
          "Importe",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let totalTotal = 0;
    const data = ListaSurtidos.map((a) => {
      totalTotal = totalTotal + a.total_general;
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.area,
          a.vendedor,
          a.paqueteria,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.comisionFlete),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({ compressPdf: true });
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 155, 15, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Almacen",
          "Vendedor",
          "Paqueteria",
          "flete",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalTotal),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Notas",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  function cancelarNota(idNota) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Nota!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_SURTIDOS}Cancel/${idNota}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Good job!", "Enviado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  async function PDFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    observacionesPedido,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    vendedor,
    telefono,
    creado,
    fechaHora,
    descuento,
    is_active
  ) {
    await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a.inventarios[0]._id,
              articulos: a.articulos[0].codigo,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.articulosPedido[0].precio,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
            cajas: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].cajas += item.cajas;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);

        let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);

        let TC = agrupadoValues.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let temp1 = (subTotal * descuento) / 100;

        let totalParcial = 0;

        const data = agrupadoValues
          .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
          .map((a) => {
            totalParcial = a.cantidad * a.precio;
            return [
              a.articulos,
              new Intl.NumberFormat("en-US").format(a.cajas.toFixed(2)),
              new Intl.NumberFormat("en-US").format(a.cantidad),
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(a.precio),
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(totalParcial),
            ];
          });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF({ compressPdf: true });
        var img = new Image();
        img.src = "Logo-Sistemify-PDF.png";
        doc.addImage(img, "png", 8, 15, 18, 5);
        var img2 = new Image();
        img2.src = "logoInstitucion.png";
        doc.addImage(img2, "png", 10, 21, 15, 15);

        let alto = 5;

        doc.setFontSize(12);
        doc.text(`Fecha:`, 35, alto + 15);
        doc.text(`${fecha}`, 60, alto + 15);
        doc.text(`Nota:`, 35, alto + 20);
        doc.text(`${numero}`, 60, alto + 20);
        doc.text(`Pedido:`, 35, alto + 25);
        doc.text(`${pedidos}`, 60, alto + 25);

        doc.text(`Ejecutivo:`, 120, alto + 15);
        doc.text(`${vendedor}`, 150, alto + 15);

        doc.setFontSize(8);
        doc.text(`Creado por: ${creado}`, 120, alto + 32);
        doc.text(`Fecha creado: ${fechaHora}`, 120, alto + 37);

        doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, alto + 32);
        doc.text(`RFC: ${RFC}`, 10, alto + 37);
        doc.text(
          `Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int}`,
          10,
          alto + 47
        );
        doc.text(`Telefono: ${telefono}`, 10, alto + 52);
        doc.text(`Edo: ${estado}, Ciudad: ${ciudad}, CP: ${cp}`, 10, alto + 57);
        doc.text(`Del: ${delegacion}, Col: ${colonia}`, 10, alto + 62);

        doc.setFontSize(12);
        doc.text(`Paqueteria: ${paqueteria}`, 120, alto + 50);
        doc.text(`Almacen: ${area}`, 120, alto + 57);

        if (is_active == "Si") {
          doc.autoTable({
            head: [["Articulo", "Cajas", "Cantidad", "Precio", "Total"]],
            body: dataPDFLimpia,
            styles: {
              fontSize: 12,
              // overflow: "linebreak",
              // columnWidth: "wrap",
              // // font: 'arial',
              // overflowColumns: "linebreak",
            },
            margin: { left: 7, right: 7 },
            startY: alto + 70,
            foot: [
              [
                "",
                new Intl.NumberFormat("en-US").format(TTC.toFixed(2)) +
                  " Cajas",
                new Intl.NumberFormat("en-US").format(TM) + " Piezas",
                "Sub Total",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(subTotal.toFixed(2)),
              ],
              [
                "",
                "",
                "",
                `Comision`,
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(iva.toFixed(2)),
              ],
              [
                "",
                "",
                "",
                "Comision TDC",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(comisionTDC.toFixed(2)),
              ],
              [
                "",
                "",
                "",
                "Flete",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(comisionFlete.toFixed(2)),
              ],
              [
                "",
                "",
                "",
                `Desc ${descuento}%`,
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format((-temp1).toFixed(2)),
              ],
              [
                "",
                "",
                "",
                "Total",
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(total_general.toFixed(2)),
              ],
            ],
            showFoot: "lastPage",
          });
        } else {
          doc.autoTable({
            head: [["Articulo", "Cajas", "Cantidad", "Precio", "Total"]],
            body: dataPDFLimpia,
            styles: {
              fontSize: 12,
              // overflow: "linebreak",
              // columnWidth: "wrap",
              // // font: 'arial',
              // overflowColumns: "linebreak",
            },
            margin: { left: 7, right: 7 },
            startY: alto + 70,
            foot: [["", "", "", "", "CANCELADA"]],
          });
        }
        var lines = doc.splitTextToSize(
          `Observaciones ${observacionesPedido}`,
          200
        );
        doc.text(10, doc.autoTable.previous.finalY + 10, lines);

        window.open(doc.output("bloburl"), "_blank");
        //   }
        // });
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Paqueteria", field: "paqueteria", sortable: true },
    { name: "Flete", field: "comisionFlete", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.paqueteria.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.comisionFlete.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        e.idUser.includes(selectedUser)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    // if (selectedDepartamento) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idDepartamento.includes(selectedDepartamento)
    //   );
    // }

    let activos = computedComments.filter((e) => e.is_active == "Si");
    let t = activos.map((c) => parseFloat(c.total_general));
    let Tt = t.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalTabla(Tt);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero" &&
      sorting.field != "comisionFlete" &&
      sorting.field != "total_general"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "comisionFlete" ||
        sorting.field == "total_general")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "comisionFlete" ||
        sorting.field == "total_general")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    // selectedDepartamento,
  ]);

  let totalImporteTabla = 0;

  // Toggle function for the modal
  const toggleTrackingModal = () => {
    setModalTracking(!modalTracking);
    if (modalTracking) {
      // Reset state when closing
      setTrackingFile(null);
      setTrackingPreviewUrl(null);
      setTrackingErrorMessage("");
    }
  };
  const checkTrackingImage = (ventaId) => {
    setTrackingPhoto("");
    const URL_GET_TRACKING = `${import.meta.env.VITE_URL_GETMEDIA}/${ventaId}`;
    axios
      .get(URL_GET_TRACKING, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        console.log(data);
        if (data.data.url) {
          console.log(data.data.url);
          setTrackingPhoto(data.data.url);
        }
      })
      .catch((error) => {
        console.error("Error loading tracking image:", error);
      });
  };

  const handleTrackingFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Check if file is an image
      if (!selectedFile.type.startsWith("image/")) {
        setTrackingErrorMessage(
          "Por favor seleccione un archivo de imagen válido."
        );
        return;
      }
      // Check file size (limit to 5MB)
      if (selectedFile.size > 5 * 1024 * 1024) {
        setTrackingErrorMessage("El archivo no debe superar los 5MB.");
        return;
      }
      setTrackingFile(selectedFile);
      setTrackingPreviewUrl(URL.createObjectURL(selectedFile));
      setTrackingErrorMessage("");
    }
  };

  // Handle file upload
  const handleTrackingUpload = async () => {
    if (!trackingFile) {
      setTrackingErrorMessage(
        "Por favor seleccione una imagen del número de seguimiento."
      );
      return;
    }
    
    setIsTrackingUploading(true);
    setTrackingErrorMessage("");
    
    try {
      // 1. Upload the tracking image
      const formData = new FormData();
      formData.append("file", trackingFile);
      formData.append("articulo", idVenta);
      
      const response = await axios.post(URL_FILEPOST, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      
      const photoUrl = response.data.secure_url;
      
      // 2. Log the action
      await axios.post(
        URL_LOGS,
        {
          tipo: "Subir Imagen Tracking",
          detalle: `Tracking para venta ID: ${idVenta}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      
      // 4. Generate PDF with tracking image
      const doc = new jsPDF();
      
      // Set up the PDF
      doc.setFontSize(16);
      doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, 105, 20, {
        align: "center",
      });
      doc.setFontSize(14);
      doc.text("Información de Seguimiento", 105, 30, { align: "center" });
      doc.setFontSize(12);
      doc.text(`Código: ${codigo}`, 20, 45);
      doc.text(`Cliente: ${nombre}`, 20, 55);
      doc.text(`Fecha: ${new Date().toLocaleDateString()}`, 20, 65);
      
      // Use the Cloudinary URL directly in the PDF
      // First, we need to load the image from the URL
      const imgData = await fetch(photoUrl);
      const imgBlob = await imgData.blob();
      
      // Convert blob to base64
      const reader = new FileReader();
      
      const imageDataPromise = new Promise((resolve) => {
        reader.onload = function (event) {
          resolve(event.target.result);
        };
        reader.readAsDataURL(imgBlob);
      });
      
      const imageData = await imageDataPromise;
      
      // Add image to PDF
      doc.addImage(imageData, "JPEG", 20, 80, 170, 120);
      
      doc.text("Gracias por su compra", 105, 210, { align: "center" });
      
      // Add terminos.jpeg from public folder
      try {
        // Load the terms image from public folder
        const terminosResponse = await fetch('/terminos.jpeg');
        const terminosBlob = await terminosResponse.blob();
        
        // Convert to base64
        const terminosReader = new FileReader();
        const terminosDataPromise = new Promise((resolve) => {
          terminosReader.onload = function (event) {
            resolve(event.target.result);
          };
          terminosReader.readAsDataURL(terminosBlob);
        });
        
        const terminosImageData = await terminosDataPromise;
        
        // Add a new page for the terms image
        doc.addPage();
        // Add terms image to the new page
        doc.addImage(terminosImageData, "JPEG", 10, 10, 190, 280);
      } catch (terminosError) {
        console.error("Error loading terms image:", terminosError);
        // Continue with the process even if terms image fails to load
      }
      
      // 5. Send the PDF through WhatsApp
      doc.autoPrint();
      
      var att = doc.output("arraybuffer");
      
      let params = new URLSearchParams({
        number: telefono,
        message: `Gracias Por tu compra✨🫶🏼 espero que toda la mercancia sea de tu agrado, tus prendas fueron revisadas conforme a tu pedido para evitar cualquier inconveniente😉 Te pido grabar video al desempacar tu mercancia para cualquier aclaración   quedo a tus ordenes para cualquier duda y futuros pedidos✍`,
        fileName: `Tracking-${codigo}.pdf`,
        mimetype: "application/pdf",
      });
      
      const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
      
      await axios.post(
        `${URL_WHATSAPP}SendPDFFront?${params.toString()}`,
        att,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "application/octet-stream",
          },
        }
      );
      
      // Success - close modal
      setIsTrackingUploading(false);
      toggleTrackingModal();
      
      // Show success message
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Imagen de tracking subida y enviada por WhatsApp correctamente",
      });
    } catch (error) {
      setIsTrackingUploading(false);
      setTrackingErrorMessage(
        "Error al subir la imagen. Por favor intente nuevamente."
      );
      console.error("Error uploading tracking image:", error);
      
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error al procesar la solicitud",
        footer: error.response ? `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}` : "Error de conexión",
      });
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Notas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            {/* <Col md={2}>
                <Label>Departamento</Label>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedDepartamento}
                  onChange={(e) => {
                    setSelectedDepartamento(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {departamentos
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col> */}
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if (a.is_active == "No") {
                  return (
                    <tr className="row-cancelled">
                      <td>{a.numero}</td>
                      <td>{formatDate(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      {/* <td>{a.departamentoName}</td> */}
                      <td>{a.paqueteria}</td>
                      <td></td>
                      {/* <td>{a.is_active == "Si" ? (
                        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)
                          ) : undefined}
                      </td> */}
                      <td>CANCELADA</td>
                      <td>
                        <>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) =>
                              PDFOC(
                                a.fecha,
                                a.idClientes,
                                a.clientes,
                                a.observaciones,
                                a.observacionesPedido,
                                a.numero,
                                a._id,
                                a.user,
                                a.pedidos,
                                a.comisionTDC,
                                a.comisionFlete,
                                a.impuestos,
                                a.subTotal,
                                a.iva,
                                a.total_general,
                                a.calle,
                                a.numero_ext,
                                a.numero_int,
                                a.pais,
                                a.estado,
                                a.ciudad,
                                a.delegacion,
                                a.colonia,
                                a.cp,
                                a.RFC,
                                a.paqueteria,
                                a.area,
                                a.codigoClientes,
                                a.vendedor,
                                a.telefono,
                                a.creado,
                                a.fechaHora,
                                a.descuento,
                                a.is_active
                              )
                            }
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button>
                        </>
                      </td>
                    </tr>
                  );
                } else {
                  totalImporteTabla = totalImporteTabla + a.total_general;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{formatDate(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      {/* <td>{a.departamentoName}</td> */}
                      <td>{a.paqueteria}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.comisionFlete)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total_general)}
                      </td>
                      <td>
                        <>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) =>
                              PDFOC(
                                a.fecha,
                                a.idClientes,
                                a.clientes,
                                a.observaciones,
                                a.observacionesPedido,
                                a.numero,
                                a._id,
                                a.user,
                                a.pedidos,
                                a.comisionTDC,
                                a.comisionFlete,
                                a.impuestos,
                                a.subTotal,
                                a.iva,
                                a.total_general,
                                a.calle,
                                a.numero_ext,
                                a.numero_int,
                                a.pais,
                                a.estado,
                                a.ciudad,
                                a.delegacion,
                                a.colonia,
                                a.cp,
                                a.RFC,
                                a.paqueteria,
                                a.area,
                                a.codigoClientes,
                                a.vendedor,
                                a.telefono,
                                a.creado,
                                a.fechaHora,
                                a.descuento,
                                a.is_active
                              )
                            }
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="success"
                            onClick={(e) => {
                              e.preventDefault();
                              setIdVenta(a._id);
                              setTelefono(a.telefono);
                              setNombre(a.nombre);
                              setCodigo(a.codigoClientes);
                              checkTrackingImage(a._id); // Check if tracking image exists
                              toggleTrackingModal();
                            }}
                          >
                            <i className="fas fa-truck-moving"></i>
                          </Button>
                          {user.cancelarNota ? (
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarNota(a._id)}
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              disabled
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                          )}
                         
                        </>
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalImporteTabla)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL GENERAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalTotalTabla)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <Modal isOpen={modalTracking} toggle={toggleTrackingModal} size="sm">
        <ModalHeader toggle={toggleTrackingModal}>
          <h4>
            {trackingPhoto ? "Imagen de Tracking" : "Subir Imagen de Tracking"}
          </h4>
        </ModalHeader>

        <ModalBody>
          <Row>
            <Col className="text-center mb-3">
              {trackingPreviewUrl ? (
                <div className="preview-container">
                  <img
                    src={trackingPreviewUrl}
                    alt="Vista previa de imagen"
                    className="img-fluid"
                    style={{ maxHeight: "250px", margin: "0 auto" }}
                  />
                </div>
              ) : trackingPhoto ? (
                <div className="existing-image-container">
                  <img
                    src={trackingPhoto}
                    alt="Imagen de tracking"
                    className="img-fluid"
                    style={{ maxHeight: "250px", margin: "0 auto" }}
                  />
                </div>
              ) : (
                <div className="upload-placeholder p-4 border rounded">
                  <p className="mb-0">
                    Seleccione una imagen del número de tracking
                  </p>
                </div>
              )}
            </Col>
          </Row>

          <Row className="mt-2">
            <Col>
              <div className="custom-file">
                <input
                  type="file"
                  className="custom-file-input"
                  id="trackingImage"
                  accept="image/*"
                  onChange={handleTrackingFileChange}
                />
                <label
                  className="btn btn-outline-secondary w-100"
                  htmlFor="trackingImage"
                >
                  {trackingFile
                    ? trackingFile.name
                    : trackingPhoto
                    ? "Cambiar Imagen"
                    : "Seleccionar Imagen"}
                </label>
              </div>
            </Col>
          </Row>

          {trackingErrorMessage && (
            <Row className="mt-2">
              <Col>
                <div className="alert alert-danger" role="alert">
                  {trackingErrorMessage}
                </div>
              </Col>
            </Row>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            color="secondary"
            onClick={toggleTrackingModal}
            disabled={isTrackingUploading}
          >
            Cancelar
          </Button>
          {(!trackingPhoto || trackingFile) && (
            <Button
              color="primary"
              onClick={handleTrackingUpload}
              disabled={isTrackingUploading || !trackingFile}
            >
              {isTrackingUploading
                ? "Subiendo..."
                : trackingPhoto
                ? "Actualizar"
                : "Subir Imagen"}
            </Button>
          )}
        </ModalFooter>
      </Modal>
      <br />
      {loader}
    </>
  );
}

export default ListadoVentas;
